module.exports = __webpack_public_path__ + "61486ff678acc52497df23ed5a9919e7.svg";